export default "__VITE_ASSET__cfe33139__"